import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useDidMount, useWillUnMount } from '../customHooks';
import servNameApi from '../api/masta/servNameMasta';
import titleImage from '../images/title.svg';

export const Header = function () {
  const params = useParams();

  const [title, setTitle] = useState('');
  const [lgName, setLgName] = useState('');
  const [logoFlag, setLogoFlag] = useState(false);

  const init = async () => {
    const { lgCd = '' } = params;
    if (lgCd !== '') {
      const response = await servNameApi.getServName(lgCd, 'reserve').catch((err) => {
        window.alert('サービス名の取得に失敗しました。');
      });

      const { servName = '', lgName = '', logo = false } = response;

      setTitle(servName);
      setLgName(lgName);
      setLogoFlag(logo);
      return;
    }

    setTitle('');
    setLgName('');
    return;
  };

  useDidMount(() => {
    init();
  });

  return (
    <header id="siteHeader" className="row aiC">
      <div className="col2">
        <h1>
          {logoFlag ? (
            <img src={titleImage} alt="Open LINK for LIFE みんなの窓口" width="144" height="33" />
          ) : (
            // `${lgName} ${title}`
            `${title}`
          )}
        </h1>
      </div>
      <div id="user" className="col2 row aiC jcFE">
        {lgName}
      </div>
    </header>
  );
};

export const ReserveHeader = function (props) {
  // サービス名検索に使用
  const { lgCd = '' } = props;

  const [serviceName, setServiceName] = useState('');
  const [displayLgName, setDisplayLgName] = useState('');
  const [logoFlag, setLogoFlag] = useState(false);

  /**
   * 表示サービス名の取得
   * @param {string} lgCd 自治体コード
   * @return {void}
   */
  const getServiceName = async (lgCd) => {
    if (lgCd === '') {
      return;
    }
    const response = await servNameApi.getServName(lgCd, 'reserve').catch((err) => {
      window.alert('サービス名の取得に失敗しました。');
      return false;
    });

    const { servName = '', lgName = '', logo = false } = response;

    setServiceName(servName);
    setDisplayLgName(lgName);
    setLogoFlag(logo);
  };

  useEffect(() => {
    getServiceName(lgCd);
  }, [lgCd]);

  useDidMount(() => {
    getServiceName(lgCd);
  });

  return (
    <header id="siteHeader" className="row aiC">
      <div className="col2">
        <h1>
          {logoFlag ? (
            <img src={titleImage} alt="Open LINK for LIFE みんなの窓口" width="144" height="33" />
          ) : (
            // `${displayLgName} ${serviceName}`
            `${serviceName}`
          )}
        </h1>
      </div>
      <div id="user" className="col2 row aiC jcFE">
        {displayLgName}
      </div>
    </header>
  );
};

export default Header;
